module.exports = "/_next/static/files/f5de3309eec11fe75302cb6da727e408.jpg";